import { PromotedBadge } from "@faire/retailer-visitor-shared/features/ADS/PromotedBadge";
import { shouldShowPromotedBadge as getShouldShowPromotedBadge } from "@faire/retailer-visitor-shared/features/ADS/util";
import { TextBadgesClientWrapper } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TextBadges/__internal__/TextBadgesClientWrapper";
import { textBadgesClientWrapperAdaptor } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TextBadges/__internal__/textBadgesClientWrapperUtils";
import { TextBadgesProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TextBadges/textBadgesProps";
import React from "react";

interface IProps {
  data: TextBadgesProps;
}

export const TextBadges: React.FC<IProps> = ({ data }) => {
  const shouldShowPromotedBadge = getShouldShowPromotedBadge(
    data.isPromoted,
    data.promotedBy
  );

  return shouldShowPromotedBadge ? (
    <TextBadgesClientWrapper data={textBadgesClientWrapperAdaptor(data)}>
      <PromotedBadge noPadding />
    </TextBadgesClientWrapper>
  ) : null;
};
